import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'DASHBOARD_UPDATE',
    smsDelete : 'DASHBOARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        asset_count: {},
        volunteer_count: {},

        dashboardCountLoading: false,
        dashboardCountError: false,
 
        ...store
    },

    mutations : {
        ...mutations,

        SET_ASSET_COUNT(state, count) {
            state.asset_count = count;
        },

        SET_VOLUNTEER_COUNT(state, count) {
            state.volunteer_count = count;
        },
     
        DASHBOARD_COUNT_LOADING (state, loading) {
            state.dashboardCountLoading = loading;
        },

        DASHBOARD_COUNT_ERROR (state, hasError) {
            state.dashboardCountError = hasError;
        }
    },

    actions: {
        async fetchAssetCount ({ commit }) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_asset_count, config);
                let response = result.data
                commit('SET_ASSET_COUNT', response.data);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        },
        
        async fetchVolunteerCount ({ commit },payload) {
            commit('DASHBOARD_COUNT_LOADING', true);
            commit('DASHBOARD_COUNT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_volunteer_count, config);
                let response = result.data
                commit('SET_VOLUNTEER_COUNT', response);

            } catch(error) {
                commit('DASHBOARD_COUNT_ERROR', true);
            } finally {
                commit('DASHBOARD_COUNT_LOADING', false);
            }
        }
    },

    getters: {}
}
